<ng-container *ngIf="translationStatus$ | async">
    <ng-container *cidContentLoader="contentLoading">
        <!--    <h1 class="mb30">{{ "PASSWORD_SET.SET_NEW_PASSWORD" | translate }}</h1>-->
        <span class="custom-login-info" style="margin-bottom: 20px; display: block;">Neues Passwort festlegen</span>

        <dynamic-form
            [fields]="fields"
            [options]="dynamicFormOptions"
            [isSubmitted]="isSubmitBtnClicked"
            (onSubmit)="sendResetPassword($event)"
            (btnId)="_getFormId($event)"
        >
        </dynamic-form>

        <!--custom-->
        <!--    <p class="pw-hint">Das Passwort muss mindestens 8 Zeichen lang sein.</p>-->

        <div class="mat-error">
            {{
            (translationStatus$ | async)
                ? (routeParams$ | async | error : false)
                : ""
            }}
        </div>
        <div class="mat-error" *ngIf="errorMessage">
            {{ errorMessage | translate }}
        </div>
        <div class="mat-error" *ngIf="regFieldError">
            {{ regFieldError | translate }}
        </div>
        <div class="section btn-group">
            <!--      <a [routerLink]="[]" (click)="commonFunc.getRedirectedByRequestId()"-->
            <!--        ><label for="cidaasCancelBtn">{{ "BACK" | translate }}</label></a-->
            <!--      >-->
            <app-button class="login-btn"
                        *ngIf="fields.length > 0"
                        [btnOption]="buttonOptions.resetPwd"
            >
            </app-button>
        </div>
    </ng-container>
</ng-container>
